// extracted by mini-css-extract-plugin
export default {"CheckboxInput":"CheckboxInput_CheckboxInput__8TnZ8","theme-light":"CheckboxInput_theme-light__HSBZ4","theme-dark":"CheckboxInput_theme-dark__72WDl"};